/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */

/* eslint-disable consistent-return */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Overlay } from 'react-bootstrap';
import {
  MdOutlineKeyboardArrowUp,
  MdOutlineKeyboardArrowDown,
  MdOutlineChair,
  MdClose,
} from 'react-icons/md';
import AppButton from '../../../shared/components/app-button/AppButton';
import {
  convertTravelTime,
  formatCurrency,
  formatDate,
  // formatDate,
  formatTimeString,
  formatTimeStringAmPmFormat,
  getNewDate,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';
import { ONLY_DATE_MONTH_FORMAT } from '../../../shared/constants/Constants';
import BusCancellationPolicy from './BusCancellationPolicy';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { getBusSeatLayoutApi } from '../../../api/busApi';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';

const SEAT_TYPE_COLOR_DICT = {
  Available: '#666666',
  Booked: '#E1E1DF',
  Selected: '#0d5470',
  Ladies: '#d41f48',
  Gents: '#6951FF',
  SelectedBackground: '#afd9ea',
  LadiesSelectedBackground: '#fae8ed',
};

const MAX_SEAT_ALLOWED = 6;

function BusCard({
  busData,
  searchRequest,
  onBook,
  showCommission,
  busOptionsToShare,
  onSelectForShare,
}) {
  const cancellationOverlaytarget = useRef(null);
  const [openCancellationPolicy, setOpenCancellationPolicy] = useState(false);
  const boardingDroppingOverlayTarget = useRef(null);
  const [openBordingDropping, setOpenBordingDropping] = useState(false);
  const fareDetailsOverlaytarget = useRef(null);
  const [openFareDetails, setOpenFareDetails] = useState(false);
  const [bordingPoints, setBordingPoints] = useState([]);
  const [droppingPoints, setDroppingPoints] = useState([]);
  const [showSeatLayout, setShowSeatLayout] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [userPreference, setUserPreference] = useState({ from: '', to: '' });
  const lowerBerthSeatRef = useRef([]);
  const upperBerthSeatRef = useRef([]);
  const [busCols, setBusCols] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [isBusSelectedForShare, setIsBusSelectedForShare] = useState(false);
  const [seatResponseId, setSeatReponseId] = useState(false);

  function SeatType({ type }) {
    return (
      <div className="d-flex flex-column align-items-center">
        <MdOutlineChair
          style={{
            fontSize: 24,
            color: SEAT_TYPE_COLOR_DICT[type],
          }}
        />
        <span className="bus-seat-preferences-page__seat-map-container_header_text">
          {type}
        </span>
      </div>
    );
  }

  const getBordingDroppingPoints = () => {
    try {
      let bording = busData.boardingpoints;
      bording = Array.isArray(bording) ? bording : [bording];
      let dropping = busData.droppoints;
      dropping = Array.isArray(dropping) ? dropping : [dropping];
      setUserPreference({ from: bording[0].id, to: dropping[0].id });
      setBordingPoints(bording);
      setDroppingPoints(dropping);
    } catch (e) {
      console.log('Error in boarding dropping points', e);
    }
  };

  const getLabel = (time, address) => {
    let label = '';
    if (address) label += `${address}`;
    if (time) label += ` (${formatTimeString(time)})`;
    return label;
  };

  useEffect(() => {
    getBordingDroppingPoints();
  }, []);

  const getBusSeatLayout = async () => {
    setIsLoading(true);
    const response = await getBusSeatLayoutApi(busData, searchRequest);
    if (response.apistatus?.status === 'OK') {
      const seats = response.seats || [];
      const { seatresponseid } = response;
      setSeatReponseId(seatresponseid);
      const lowerBearth = seats.filter((seat) => seat.zIndex === 0);
      lowerBerthSeatRef.current = Array.isArray(lowerBearth)
        ? lowerBearth
        : [lowerBearth];
      const availCols = [];
      lowerBerthSeatRef.current.forEach((seat) => {
        if (!availCols.some((x) => x === seat.column)) {
          availCols.push(seat.column);
        }
      });
      availCols.sort((a, b) => a - b);
      setBusCols(availCols);
      const upperBearth = seats.filter((seat) => seat.zIndex === 1);
      upperBerthSeatRef.current = Array.isArray(upperBearth)
        ? upperBearth
        : [upperBearth];
      if (seats.length > 0) {
        setShowSeatLayout(true);
      } else {
        setAlert({
          variant: 'error',
          description: 'No Seat Found',
        });
      }
    } else {
      setAlert({
        variant: 'error',
        description: response.apistatus?.message,
      });
    }
    setIsLoading(false);
  };

  const getSleeperIconStyle = (seat) => {
    const style = { borderColor: '', cursor: '' };
    if (seat.available) {
      style.cursor = 'pointer';
      if (seat.ladiesSeat) {
        style.borderColor = SEAT_TYPE_COLOR_DICT.Ladies;
      } else {
        style.borderColor = SEAT_TYPE_COLOR_DICT.Available;
      }
    } else if (!seat.available) {
      style.borderColor = SEAT_TYPE_COLOR_DICT.Booked;
      if (seat.ladiesSeat) {
        style.backgroundColor = SEAT_TYPE_COLOR_DICT.LadiesSelectedBackground;
        style.borderColor = SEAT_TYPE_COLOR_DICT.LadiesSelectedBackground;
      }
    }
    const found = selectedSeats.find((d) => d.name === seat.name);
    if (found) {
      style.cursor = 'pointer';
      if (found.ladiesSeat) {
        style.borderColor = SEAT_TYPE_COLOR_DICT.Ladies;
        style.backgroundColor = SEAT_TYPE_COLOR_DICT.LadiesSelectedBackground;
      } else {
        style.borderColor = SEAT_TYPE_COLOR_DICT.Selected;
        style.backgroundColor = SEAT_TYPE_COLOR_DICT.SelectedBackground;
      }
    }
    return style;
  };

  const onSeatSelect = (seat) => {
    const selected = [...selectedSeats];
    const index = selected.findIndex((d) => d.name === seat.name);
    if (index === -1) {
      if (selected.length < MAX_SEAT_ALLOWED) {
        selected.push(seat);
      } else {
        setAlert({
          variant: 'error',
          title: 'Bus Seat Selection',
          description: `You already select ${MAX_SEAT_ALLOWED} seats`,
        });
      }
    } else {
      selected.splice(index, 1);
    }
    setSelectedSeats(selected);
  };

  const getSeatIconStyle = (seat) => {
    const style = { fontSize: 24, color: '', cursor: '', backgroundColor: '' };
    if (seat.available) {
      style.cursor = 'pointer';
      if (seat.ladiesSeat) {
        style.color = SEAT_TYPE_COLOR_DICT.Ladies;
        style.fill = SEAT_TYPE_COLOR_DICT.Ladies;
      } else {
        style.color = SEAT_TYPE_COLOR_DICT.Available;
        style.fill = SEAT_TYPE_COLOR_DICT.Available;
      }
    } else if (!seat.available) {
      style.color = SEAT_TYPE_COLOR_DICT.Booked;
      style.fill = SEAT_TYPE_COLOR_DICT.Booked;
      if (seat.ladiesSeat) {
        style.fill = SEAT_TYPE_COLOR_DICT.LadiesSelectedBackground;
      }
    }
    const found = selectedSeats.find((d) => d.name === seat.name);
    if (found) {
      style.cursor = 'pointer';
      if (found.ladiesSeat) {
        style.color = SEAT_TYPE_COLOR_DICT.Ladies;
        style.fill = SEAT_TYPE_COLOR_DICT.LadiesSelectedBackground;
      } else {
        style.color = SEAT_TYPE_COLOR_DICT.Selected;
        style.fill = SEAT_TYPE_COLOR_DICT.SelectedBackground;
      }
    }
    return style;
  };

  const getSeatNameStyle = (seat) => {
    const style = { cursor: '' };
    if (seat.available) {
      style.cursor = 'pointer';
    }
    const found = selectedSeats.find((d) => d.name === seat.name);
    if (found) {
      style.cursor = 'pointer';
    }
    return style;
  };

  const Seat = ({ isEmpty, seat }) => {
    if (isEmpty) {
      return <div className="empty-seat" />;
    }
    if (!isEmpty) {
      if (seat.length === 1 && seat.width === 1) {
        return (
          <div className="seat">
            <MdOutlineChair
              title={`Seat No: ${seat.name}, Fare: ${formatCurrency(
                seat.totalnet,
              )}`}
              onClick={() => (seat.available ? onSeatSelect(seat) : undefined)}
              style={getSeatIconStyle(seat)}
            />
            <span
              className="seat-name"
              style={getSeatNameStyle(seat)}
              onClick={() => (seat.available ? onSeatSelect(seat) : undefined)}
            >
              {seat.name}
            </span>
          </div>
        );
      }
      if (seat.length === 2 || seat.width === 2) {
        return (
          <div className="seat sleeper-seat">
            <div
              className={`${
                seat.width === 2
                  ? 'sleeper-seat_icon-horizontal'
                  : 'sleeper-seat_icon'
              }`}
              onClick={() => (seat.available ? onSeatSelect(seat) : undefined)}
              style={getSleeperIconStyle(seat)}
              title={`Seat No: ${seat.name}, Fare: ${formatCurrency(
                seat.totalnet,
              )}`}
            />
            <span
              className={` ${
                seat.width === 2
                  ? 'sleeper-seat_icon-horizontal_name'
                  : 'sleeper-seat_icon_name'
              }`}
              style={getSeatNameStyle(seat)}
              onClick={() => (seat.available ? onSeatSelect(seat) : undefined)}
            >
              {seat.name}
            </span>
          </div>
        );
      }
    }
  };

  const generateSeatLayout = (seatDict) => {
    const availrows = [];
    // let availCols = [];
    seatDict.forEach((seat) => {
      if (!availrows.some((x) => x === seat.row)) {
        availrows.push(seat.row);
      }
    });
    availrows.sort((a, b) => a - b);
    const seatLayout = [];
    for (
      let row = availrows[0];
      row <= availrows[availrows.length - 1];
      row++
    ) {
      const currentRow = [];
      for (let col = busCols[0]; col <= busCols[busCols.length - 1]; col++) {
        const seatAvailable = seatDict.find(
          (seat) => seat.row === row && seat.column === col,
        );
        if (seatAvailable) {
          currentRow.push(<Seat seat={seatAvailable} isEmpty={false} />);
        } else {
          currentRow.push(<Seat isEmpty />);
        }
      }
      seatLayout.push(<div key={`row-${row}`}>{currentRow}</div>);
    }
    return seatLayout;
  };

  const handleDropdownChange = (dataObj, name) => {
    setUserPreference({ ...userPreference, [name]: dataObj.value });
  };

  const handleShowSeatLayout = () => {
    if (!showSeatLayout) {
      getBusSeatLayout();
    } else {
      setShowSeatLayout(false);
    }
  };

  const handleContinue = () => {
    if (userPreference.from === '') {
      setAlert({
        variant: 'error',
        title: 'Bus Selection',
        description: 'Please select pick up point',
      });
      return false;
    }
    if (userPreference.to === '') {
      setAlert({
        variant: 'error',
        title: 'Bus Selection',
        description: 'Please select dropping point',
      });
      return false;
    }
    if (userPreference.from && userPreference.to) {
      if (selectedSeats.length === 0) {
        setAlert({
          variant: 'error',
          title: 'Bus Seat Selection',
          description: 'Please select seat',
        });
        return false;
      }
    }
    onBook(selectedSeats, userPreference, busData, seatResponseId);
  };

  const handlecheckBox = () => {
    const isPresent = busOptionsToShare.some(
      (d) => d.nextrabusid === busData.nextrabusid,
    );
    setIsBusSelectedForShare(isPresent);
  };

  useEffect(() => {
    handlecheckBox();
  }, [busOptionsToShare]);

  useEffect(() => {}, [busOptionsToShare]);

  const handleBusSelectionForShare = () => {
    onSelectForShare(busData);
  };

  const handleOnCardClick = () => {
    if (!isMobileWidth()) {
      return;
    }
    handleShowSeatLayout();
  };

  return (
    <>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <Card className="bus-search-results-page__body_card-section_card">
        <Card.Body className="p-2 pb-1" onClick={handleOnCardClick}>
          <Row className="spacing-8">
            <Col lg={12}>
              <Row className="spacing-8">
                <Col
                  className="bus-search-results-page__body_card-section_card_bus-details d-flex justify-content-between flex-column"
                  lg={4}
                  md={4}
                  sm={6}
                  xs={9}
                >
                  <div>
                    <div className="bus-search-results-page__body_card-section_card_bus-details_name">
                      {busData.operatorname}
                    </div>
                    <div className="bus-search-results-page__body_card-section_card_bus-details_type">
                      <span>{busData.bustype}</span>
                    </div>
                  </div>
                  {!isMobileWidth() && (
                    <div>
                      <AppCheckBox
                        name="busSelectedForShare"
                        id={busData.nextrabusid}
                        labelText="Share via Email or Whatsapp"
                        labelClassName="fw-300 mt-2"
                        checked={isBusSelectedForShare}
                        onChange={handleBusSelectionForShare}
                      />
                    </div>
                  )}
                </Col>
                {isMobileWidth() && (
                  <Col xs={3}>
                    <div className="d-flex align-items-end flex-column gap-1">
                      <span
                        className="fw-600 hotel-results-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(busData.supplierfares[0].totalnet)}
                      </span>
                      {showCommission && (
                        <span
                          className="dark-grey-color fs-10 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(busData.seatdetails?.totalnet_seat)}
                        </span>
                      )}
                      <span className="dark-grey-color fs-10">{`${busData.seatdetails?.numseatsavailable} Seats Left`}</span>
                    </div>
                  </Col>
                )}
                <Col
                  className="bus-search-results-page__body_card-section_card_timings"
                  lg={6}
                  md={6}
                  sm={6}
                >
                  <Row>
                    <Col
                      className="d-flex flex-column"
                      lg={5}
                      md={5}
                      sm={5}
                      xs={4}
                    >
                      <span className="fw-600 black-color">
                        {formatTimeString(busData.deptime)}
                      </span>
                      <span className="fs-12">
                        {formatDate(
                          getNewDate(busData.departuredate),
                          ONLY_DATE_MONTH_FORMAT,
                        )}
                      </span>
                    </Col>
                    <Col
                      className="d-flex align-items-center justify-content-center px-0"
                      lg={2}
                      md={2}
                      sm={2}
                      xs={4}
                    >
                      <span className="bus-search-results-page__body_card-section_card_timings_duration">
                        {convertTravelTime(busData.duration)}
                      </span>
                    </Col>
                    <Col
                      className="d-flex flex-column align-items-end"
                      lg={5}
                      md={5}
                      sm={5}
                      xs={4}
                    >
                      <span className="fw-600">
                        {formatTimeString(busData.arrtime)}
                      </span>
                      <span className="fs-12">
                        {formatDate(
                          getNewDate(busData.arrivaldate),
                          ONLY_DATE_MONTH_FORMAT,
                        )}
                      </span>
                    </Col>
                  </Row>
                </Col>
                {!isMobileWidth() && (
                  <Col lg={2} md={2} sm={2}>
                    <div className="d-flex align-items-end flex-column gap-1">
                      <span
                        className="fw-600 hotel-results-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(busData.supplierfares[0].totalnet)}
                      </span>
                      {showCommission && (
                        <span
                          className="dark-grey-color fs-10 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(busData.seatdetails?.totalnet_seat)}
                        </span>
                      )}
                      <AppButton
                        btnText="Select Seats"
                        onClick={handleShowSeatLayout}
                        variant="primary"
                        className="px-3 py-1 fs-14 bus bus-search-results-page__body_select-seat-btn"
                      />
                      <span className="dark-grey-color fs-10">{`${busData.seatdetails?.numseatsavailable} Seats Left`}</span>
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Card.Body>
        <div className="bus-search-results-page__body_card-section_card_actions">
          <div
            className="bus-search-results-page__body_card-section_card_actions_chip"
            ref={boardingDroppingOverlayTarget}
            onClick={() => setOpenBordingDropping(!openBordingDropping)}
          >
            <span className={openBordingDropping ? 'red-color' : ''}>
              Bording & Dropping Points
            </span>
            {openBordingDropping ? (
              <MdOutlineKeyboardArrowUp />
            ) : (
              <MdOutlineKeyboardArrowDown />
            )}
          </div>
          <Overlay
            rootClose
            target={boardingDroppingOverlayTarget.current}
            show={openBordingDropping}
            placement="bottom-start"
            onHide={() => setOpenBordingDropping(false)}
          >
            {({ placement, arrowProps, show: _show, popper, ...props }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                }}
                className="bording-dropping-list-overlay"
              >
                <div className="d-flex">
                  <span className="flex-1 text-center fs-14 fw-500">
                    Bording Points
                  </span>
                  <span className="flex-1 text-center fs-14 fw-500">
                    Dropping Points
                  </span>
                </div>
                <div className="d-flex">
                  {bordingPoints.length > 0 && (
                    <div className="list-view">
                      {bordingPoints.map((location) => (
                        <div
                          key={location.id}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <span style={{ marginRight: '3px' }}>
                            {location.name}
                          </span>
                          <span>{formatTimeString(location.bdtime)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {droppingPoints.length > 0 && (
                    <div className="list-view">
                      {droppingPoints.map((location) => (
                        <div
                          key={location.id}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <span style={{ marginRight: '3px' }}>
                            {location.name}
                          </span>
                          <span>{formatTimeString(location.bdtime)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </Overlay>
          <div
            className="bus-search-results-page__body_card-section_card_actions_chip"
            ref={cancellationOverlaytarget}
            onClick={() => setOpenCancellationPolicy(!openCancellationPolicy)}
          >
            <span className={openCancellationPolicy ? 'red-color' : ''}>
              Cancellation Policy
            </span>
            {openCancellationPolicy ? (
              <MdOutlineKeyboardArrowUp />
            ) : (
              <MdOutlineKeyboardArrowDown />
            )}
          </div>
          <Overlay
            rootClose
            target={cancellationOverlaytarget.current}
            show={openCancellationPolicy}
            placement="bottom-start"
            onHide={() => setOpenCancellationPolicy(false)}
          >
            {({ placement, arrowProps, show: _show, popper, ...props }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                }}
                className="bus-card-overlay fs-12"
              >
                <BusCancellationPolicy
                  cancellationPolicyString={busData.cancellation_policy}
                />
              </div>
            )}
          </Overlay>
          {!isMobileWidth() && (
            <div
              className="bus-search-results-page__body_card-section_card_actions_chip"
              ref={fareDetailsOverlaytarget}
              onClick={() => setOpenFareDetails(!openFareDetails)}
            >
              <span className={openFareDetails ? 'red-color' : ''}>
                Fare Details
              </span>
              {openFareDetails ? (
                <MdOutlineKeyboardArrowUp />
              ) : (
                <MdOutlineKeyboardArrowDown />
              )}
            </div>
          )}
          <Overlay
            rootClose
            target={fareDetailsOverlaytarget.current}
            show={openFareDetails}
            placement="bottom-start"
            onHide={() => setOpenFareDetails(false)}
          >
            {({ placement, arrowProps, show: _show, popper, ...props }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                }}
                className="bus-card-overlay"
              >
                <div className="fare-details d-flex flex-column gap-1">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fs-12">Base Fare</span>
                    <span
                      className="fs-14 fw-500 hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(busData.supplierfares[0].basefare || 0)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fs-12">Handling Charges</span>
                    <span
                      className="fs-14 fw-500 hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(
                        busData.supplierfares[0].handlingcharges || 0,
                      )}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fs-12">GST</span>
                    <span
                      className="fs-14 fw-500 hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(busData.supplierfares[0].servicetax || 0)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fs-12">Markup</span>
                    <span
                      className="fs-14 fw-500 hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(busData.supplierfares[0].markup || 0)}
                    </span>
                  </div>
                  {showCommission && (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fs-12">Commission</span>
                        <span
                          className="fs-14 fw-500 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(
                            busData.supplierfares[0].discount || 0,
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fs-12">Tds</span>
                        <span
                          className="fs-14 fw-500 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(busData.supplierfares[0].tds || 0)}
                        </span>
                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fs-12">Total Fare</span>
                    <span
                      className="fs-14 fw-500 hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(busData.supplierfares[0].totalnet)}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </Overlay>
          {isMobileWidth() && (
            <div>
              <AppCheckBox
                name="busSelectedForShare"
                id={busData.nextrabusid}
                labelText="Share"
                labelClassName="fw-300 fs-12"
                checked={isBusSelectedForShare}
                onChange={handleBusSelectionForShare}
              />
            </div>
          )}
        </div>
        {showSeatLayout && (
          <section className="bus-seat-preferences-page">
            <Row className="spacing-8">
              <Col lg={5} md={5} sm={12}>
                <div className="bus-seat-preferences-page__seat-map-container">
                  <div className="bus-seat-preferences-page__seat-map-container_header">
                    <SeatType type="Available" />
                    <SeatType type="Booked" />
                    <SeatType type="Ladies" />
                    <SeatType type="Gents" />
                  </div>
                  <div className="bus-seat-preferences-page__seat-map-container_body">
                    <div className="bus-seats-container">
                      <div>
                        <div className="text-center mt-2 bus-seat-text-info">
                          Lower berth
                        </div>
                        <div className="bus-seats-container_layout">
                          <div className="bus-seat-preferences-page__seat-map-container_body_cabin mb-2">
                            <span className="bus-seat-preferences-page__seat-map-container_header_text">
                              Cabin
                            </span>
                          </div>
                          <div className="d-flex justify-content-center">
                            <div className="d-flex flex-row-reverse">
                              {generateSeatLayout(lowerBerthSeatRef.current)}
                            </div>
                          </div>
                        </div>
                      </div>

                      {upperBerthSeatRef.current.length > 0 && (
                        <div>
                          <div className="text-center mt-2 bus-seat-text-info">
                            Upper Berth
                          </div>
                          <div className="bus-seats-container_layout">
                            <div className="bus-seat-preferences-page__seat-map-container_body_cabin mb-2">
                              <span className="bus-seat-preferences-page__seat-map-container_header_text">
                                Cabin
                              </span>
                            </div>
                            <div className="d-flex justify-content-center">
                              <div className="d-flex flex-row-reverse">
                                {generateSeatLayout(upperBerthSeatRef.current)}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      <p className="bus-seat-preferences-page__seat-map-container_body_info-text mb-0">
                        The seat numbers are indicative & not guaranteed. The
                        bus operator reserves the right to change the seat
                        numbers
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={7} md={7} sm={12}>
                <div className="mt-sm-5 mt-2 custom-form">
                  <div>
                    <AppSelect
                      placeholder="Select Boarding Point"
                      label="Boarding Point"
                      className="app-select"
                      name="from"
                      options={
                        bordingPoints && bordingPoints?.length > 0
                          ? bordingPoints.map((d) => {
                              return {
                                value: d.id,
                                label: getLabel(d.bdtime, d.address),
                              };
                            })
                          : []
                      }
                      selectedValue={String(userPreference.from)}
                      onSelect={handleDropdownChange}
                      isClearable={false}
                    />
                  </div>
                  <div className="mt-3">
                    <AppSelect
                      placeholder="Select Dropping Point"
                      label="Dropping Point"
                      className="app-select"
                      name="to"
                      options={
                        droppingPoints && droppingPoints?.length > 0
                          ? droppingPoints.map((d) => {
                              return {
                                value: d.id,
                                label: getLabel(d.bdtime, d.address),
                              };
                            })
                          : []
                      }
                      selectedValue={String(userPreference.to)}
                      onSelect={handleDropdownChange}
                      isClearable={false}
                    />
                    {/* <small className="validation-error">
                {errors.to && errors.to}
              </small> */}
                  </div>
                </div>
                <div className="d-flex align-items-baseline justify-content-between mt-sm-4 mt-2">
                  <div style={{ width: '60%' }}>
                    <div>
                      <MdOutlineChair className="bus-seat-preferences-page__seat-icon" />
                      <span className="ms-2 bus-seat-preferences-page__column-label">
                        Seat no.
                      </span>
                    </div>
                    <div className="d-flex flex-wrap">
                      {selectedSeats.length > 0
                        ? selectedSeats.map((d) => (
                            <div
                              className="bus-seat-preferences-page__selected-seat"
                              key={d.name}
                            >
                              <span>{d.name}</span>
                              <MdClose
                                title="Remove seat"
                                onClick={() => onSeatSelect(d)}
                              />
                            </div>
                          ))
                        : '-'}
                    </div>
                  </div>
                  <div className="d-flex flex-column ms-5">
                    <span className="bus-seat-preferences-page__column-label">
                      Total Amount
                    </span>
                    <span
                      className="bus-seat-preferences-page__fare  hotel-results-watermarked"
                      data-watermark={`${getUserAgentId()}`}
                    >
                      {formatCurrency(
                        selectedSeats.reduce(
                          (acc, cur) => acc + cur.totalnet,
                          0,
                        ),
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex mt-sm-5 mt-2 justify-content-center">
                  <AppButton
                    variant="primary"
                    onClick={handleContinue}
                    btnText="Continue"
                    className="px-5"
                  />
                </div>
              </Col>
            </Row>
          </section>
        )}
      </Card>
    </>
  );
}

BusCard.propTypes = {
  busData: PropTypes.object.isRequired,
  onBook: PropTypes.func.isRequired,
  searchRequest: PropTypes.object.isRequired,
  showCommission: PropTypes.bool.isRequired,
  busOptionsToShare: PropTypes.any.isRequired,
  onSelectForShare: PropTypes.func.isRequired,
};

export default BusCard;
